export default {
  'feedback-module:did-pet-eat-product:title': 'Did your dog / cat eat the product?',
  'feedback-module:explanation:dog:subtitle':
    'Your feedback helps us find the right food for your dog.',
  'feedback-module:explanation:cat:subtitle':
    'Your feedback helps us find the right food for your cat.',
  'feedback-module:complete:title:thank-you': 'Thank you!',
  'feedback-module:complete:description':
    'We are processing your answer to provide more suitable food recommendations.',
  'feedback-module:button:no': 'No',
  'feedback-module:button:skip': 'Skip',
  'feedback-module:button:yes': 'Yes',
  'feedback-module:image:alt': 'Cat and dog cuddling',
};
